/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { FilePlaceholderOptions } from './file-placeholder.interface';
import { ZuperDialogService } from '@zuper/components/zuper-dialog';
import { PdfRendererWrapperComponent } from '../pdf-renderer-wrapper/pdf-renderer-wrapper.component';

@Component({
    selector: 'file-placeholder',
    templateUrl: './file-placeholder.component.html',
    styleUrls: ['./file-placeholder.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FilePlaceholderComponent implements OnInit {
    @Input() options: FilePlaceholderOptions;
    @Input() showRemoveButton?: boolean = true;
    @Output() fileEventEmitter: EventEmitter<any> = new EventEmitter();
    constructor(
        private localisationService: LocalisationService,
        private utilityService: UtilityService,
        private zuperDialogService: ZuperDialogService,
    ) {
    }

    ngOnInit(): void {
        this.localisationService.setDefaultLanguage();
    }

    getAttachmentType(attachement: string): string {
        let type: string = 'file';
        if (attachement) {
            const splittedValue: string[] = attachement.split('.');
            type = splittedValue[splittedValue.length - 1];
        }
        return type;
    }

    getAttachmentObj(): any {
        return {
            attachment: this.options.fileLink,
            attachment_name: this.options.fileName,
            attachment_size: this.options.fileSize,
            attachment_type: this.options.fileType
        };
    }

    removeFile(): void {
        this.fileEventEmitter.emit({ 'type': 'remove', 'data': this.getAttachmentObj() });
    }

    downloadFile(event: any): void {
        event.preventDefault();
        event.stopPropagation();
        this.fileEventEmitter.emit({ 'type': 'download', 'data': this.getAttachmentObj() });
    }

    openFile(): void {
        const fileNameArray: Array<string> = this.options.fileName.split('.');
        const fileType: string = fileNameArray[fileNameArray.length - 1].toLowerCase();
        if (fileType === 'pdf') {

            this.zuperDialogService.openCustom(PdfRendererWrapperComponent, {
                data: this.options,
                extraClass: 'pdf-viewer-dialog-overflow-hidden',
                width: '100vw',
                height: '100vh'
              });
        } else {
            window.open(
                this.utilityService.getFilePreviewURL(this.options.fileLink), '_blank'
            );
        }
    }

    toggleVisibility(): void {
        this.options.visible_to_customer = !this.options.visible_to_customer;
        // Emit event to parent component to handle the visibility change
        this.fileEventEmitter.emit({ 'type': 'visible', 'data': this.options.visible_to_customer });
    }
}
